<template>
  <v-list class="notification-panel">
    <div class="notification-header">
      <span class="notification-titre">Notifications</span>
      <v-btn-toggle
          v-model="filterMode"
          mandatory
          density="compact"
          class="toggle-container"
      >
        <v-btn value="all" class="toggle-button">Toutes</v-btn>
        <v-btn value="unread" class="toggle-button">
          Non lues
          <span v-if="unreadCount > 0" class="ms-1">
            ({{ unreadCount }})
          </span>
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-list-item
        v-for="notif in filteredNotifications"
        :key="notif.id"
    >
      <notification-item
          :notif="notif"
          @selected="selected"
          @deleted="deleted"
      />
    </v-list-item>

  </v-list>
</template>


<script lang="ts">
import NotificationItem from '@/framework/notif/components/NotificationItem.vue';
import Notif from '@/generated/classes/Notif';
import { CiRouter } from '@/framework/base/helpers/NavHelper';
import { goToModule } from '@/framework/base/helpers/NavHelper';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { defineComponent, type PropType } from "vue";
import {useRoute, useRouter} from "vue-router";
import { Modules } from '@/generated/classes/AppSchema';

export default defineComponent({
  components: { NotificationItem },
  props: {
    notifications: {
      type: Array as PropType<Notif[]>
    }
  },
  data() {
    return {
      router: useRouter(),
      route: useRoute(),
      filterMode: 'all'
    }
  },
  computed: {
    filteredNotifications() {
      if (!this.notifications || this.notifications.length == 0) {
        return [];
      }

      let list = this.notifications;

      if (this.filterMode == 'unread') {
        list = list.filter(n => !n.isRead);
      }

      return list.slice().sort((a, b) => new Date(b.echeance) - new Date(a.echeance));
    },
    unreadCount() {
      return this.notifications.filter(n => !n.isRead).length;
    },

  },
  methods: {
    async selected(notif: Notif): Promise<void> {
      if (notif.code == 'CALCUL_PAIE_IMPOSSIBLE') {
        await Notif.dialog(notif);
      } else {
        if (notif.route && notif.route.module != Modules.NONE) {
          goToModule(this.router, notif.route);
        }
        if (notif.route.isDialog) {
          CiRouter.addRoute(notif.route);
        }
      }
      this.readNotif(notif);
      this.$emit('close')
    },
    deleted(notif: Notif) {
      this.clearNotifType(notif);
    },
    readNotif(notif: Notif) {
      notif.isRead = true;
      notif.updateForStoreNotif();
    },
    clearNotifType(notif: Notif) {
      if (notif.type == NotifDefTypes.INFO) {
        notif.deleteForStoreNotif();
      }
    }
  }
})

</script>
